import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { TraduccionesComponent } from '../../../Alsa-MA-Angular-utils/src/app/traducciones.component';

/*---------------------------------------------- Variables Liferay ----------------------------------------------*/
declare var i18nVS: any;

/*--------------------------------------------- Variables Globales ---------------------------------------------*/
declare var google: any;
declare var initAutocomplete: any;
declare var initDateInputs: any;
declare var setJsPreference: any;
declare var setJsDate: any;
declare var idCiudadLiferay: any;
declare var rutasOfrecidas: any;
declare var map: any;
declare var errorRecogiendoRutas: any;
declare var textoErrorRecogiendoRutas: any;

declare function initMap(): any;
declare function calcRoute(): any;

@Component({
    selector: 'app-optimal-path',
    templateUrl: './optimal-path.component.html',
    styleUrls: ['./optimal-path.component.css'],
    encapsulation: ViewEncapsulation.None
})

export class AppComponent {
    /*---------------------------------------------- Variables Liferay ----------------------------------------------*/
    i18nL = TraduccionesComponent.arrayTraducciones;

    /*------------------------------------------------ Variables VSC -------------------------------------------------*/
    depClass = 'invisible';
    arrClass = 'invisible';
    classform = '';
    mapClass = 'hidden';
    dirClass = 'invisible';
    listClass = 'invisible';
    panelText = 'Abrir';

    textoErrorRecogiendoRutas = '';
    errorClass = 'invisible';
    spinnerClass = 'invisible';

    depDate: Date;
    arrDate: Date;

    ciudadActual = '';

    origenPrevioText = '';
    destinoPrevioText = '';

    rutasOfrecidas = [];

    // Clase que le añade un padding al componente cuando no esta desplegado
    optimalPathPaddingClass = "margin-bottom-form";

    firstOrigen = true; // limita la accion de "setteo" de ciudad en el origen a solo la primera vez
    firstDestino = true;    // limita la accion de "setteo" de ciudad en el destino a solo la primera vez
  
    /*----------------------------------------------- Funciones ----------------------------------------------------*/
    public setTraducciones() {
        if (typeof i18nVS !== 'undefined') { // Para saber si Liferay esta disponible o no
            this.i18nL = i18nVS;
        }
        
        switch (idCiudadLiferay) {
            case "1":
                this.ciudadActual = 'marrakech';
                break;
            case "2":
                this.ciudadActual = 'agadir';
                break;
            case "3":
                this.ciudadActual = 'tanger';
                break;
            case "4":
                this.ciudadActual = 'khouribga';
                break;
            case "5":
                this.ciudadActual = 'rabat';
                break;
        }
    }

    // Polyline estandar de google
    flightPath = null;
    marcadorInicioRuta = null;
    marcadorFinalRuta = null;
    
    public routeClickedTS(i) {
        if (this.flightPath == null) {
            this.flightPath = new google.maps.Polyline({
                path: [],
                geodesic: true,
                strokeColor: '#205d95',
                strokeOpacity: 0.7,
                strokeWeight: 3
            });
            
            this.marcadorInicioRuta = new google.maps.Marker({
                position: {lat:0, lng:0},
                title:"A"
            });
            
            this.marcadorFinalRuta = new google.maps.Marker({
                position: {lat:0, lng:0},
                title:"B"
            });
        }
        
        this.flightPath.setMap(null);
        this.marcadorInicioRuta.setMap(null);
        this.marcadorFinalRuta.setMap(null);
        
        var flightPlanCoordinates = [];
        for (var x = 0; x < this.rutasOfrecidas[i].overview_path.length; x++) {
            var coordinates = { lat: this.rutasOfrecidas[i].overview_path[x].lat(), lng: this.rutasOfrecidas[i].overview_path[x].lng() };
            flightPlanCoordinates[x] = coordinates;
        }
        this.flightPath.setPath(flightPlanCoordinates);
        this.marcadorInicioRuta.setPosition(flightPlanCoordinates[0]);
        this.marcadorFinalRuta.setPosition(flightPlanCoordinates[flightPlanCoordinates.length - 1]);
        
        this.flightPath.setMap(map);
        this.zoomToObject(this.flightPath);
        this.marcadorInicioRuta.setMap(map);
        this.marcadorFinalRuta.setMap(map);
    }
    
    public zoomToObject(obj){
        var bounds = new google.maps.LatLngBounds();
        var points = obj.getPath().getArray();
        for (var n = 0; n < points.length ; n++){
            bounds.extend(points[n]);
        }
        map.fitBounds(bounds);
    }
    
    
    public fireCalcRoute() {
        
        // Se resetean las clases
        this.listClass = 'visible';
        this.mapClass = 'visible';
        this.errorClass = 'invisible';
        this.dirClass = 'invisible';
        this.spinnerClass = 'invisible';
        this.textoErrorRecogiendoRutas = '';
        
        errorRecogiendoRutas = false;
        calcRoute();        
        this.recogerRutasCorrutine();
    }

    
    public recogerRutasCorrutine () {
        if (rutasOfrecidas.length > 0) {
            this.rutasOfrecidas = rutasOfrecidas;
            this.origenPrevioText = (<HTMLInputElement>document.getElementById('origen')).value;
            this.destinoPrevioText = (<HTMLInputElement>document.getElementById('destino')).value;                   
            
            // Se asignan las clases
            this.dirClass = 'visible';
            this.optimalPathPaddingClass = '';  
            this.spinnerClass = 'invisible';
            
            // Se asigna el valor no colapsado a todas las rutas
            for (var i = 0; i < rutasOfrecidas.length; i++) {
                this.expandedRoutes[i] = 0;   
            }            
            this.actualSelectedRoute = 0;
            initMap();
            this.routeClickedTS(0);
        } else if (errorRecogiendoRutas) { // En caso de error en la respuesta
            this.errorClass = 'visible';
            this.textoErrorRecogiendoRutas = textoErrorRecogiendoRutas;
            this.spinnerClass = 'invisible';
        } else { // Si aun se esta esperando respuesta
            this.spinnerClass = 'visible';
            setTimeout(() => this.recogerRutasCorrutine(), 0.50);
        }
    }
    
    // Calcula el tiempo que te llevaria completar una de las rutas
    public getTotalTimeOfRoute (rutaConcreta) {
        let seconds = 0;
        for (let i = 0; i < rutaConcreta.legs.length; i++) {
            seconds += rutaConcreta.legs[i].duration.value;
        }

        var finalMinutes = Math.floor((seconds / 60) % 60);
        var finalHours = Math.floor((seconds / 3600) % 24);
        
        var finalTime = '';
        if (finalMinutes < 10) {
            finalTime = '0' + finalMinutes + 'm';
        } else {
            finalTime = finalMinutes.toString(10) + 'm';
        }
        
        if (finalHours < 10 && finalHours != 0) {
            finalTime = '0' + finalHours + 'h ' + finalTime;
        } else if (finalHours != 0) {
            finalTime = finalHours.toString(10) + 'h ' + finalTime;
        }  
        
        return finalTime;
    }
    
    // Calcula si esta parte de la ruta es caminando (true) o en bus (false)
    public itsWalkingOrBus (stepConcreto) {
        if (stepConcreto.travel_mode == 'WALKING') {            
            return true;
        } else {
            return false;
        }
    } 
    
    
    public showForm() {
        this.classform = 'visible';
        this.dirClass = 'invisible';
        this.mapClass = 'hidden';
        this.panelText = 'Abrir';
        if (this.panelText === 'Cerrar') {
          this.togglePanel();
        }        
    }

    public togglePanel() {
        if (this.panelText === 'Abrir') {
            this.panelText = 'Minimizar';
            this.listClass = 'visible';
        } else {
            this.panelText = 'Abrir';
            this.listClass = 'invisible';
        }
    }
    
    public setDate($event) {
        setJsDate($event);
    }
    
    public setPreference($event) {
        setJsPreference($event.srcElement.value);
    }
    
    public travelTime($event) {
        if ($event.srcElement.value === '') {
            this.depClass = 'invisible';
            this.arrClass = 'invisible';
        } else {
            if ($event.srcElement.value === 'departure') {
                this.depClass = '';
                this.arrClass = 'invisible';
            } else {
                this.depClass = 'invisible';
                this.arrClass = '';
            }
            initDateInputs();
        }
    }

    // 0 - no expandido, 1 - si expandido
    expandedRoutes = [];
    // La ruta que actualmente esta desplegada
    actualSelectedRoute = -1;
    public toggleColapsable (iteracion) {
        this.actualSelectedRoute = iteracion;        
        this.routeClickedTS(iteracion);        
        if (this.expandedRoutes[iteracion] == 0) {
            this.expandedRoutes[iteracion] = 1;
        } else {
            this.expandedRoutes[iteracion] = 0;
        }
    }
  
    public rutaSeleccionada (iteracion) {
        if (this.actualSelectedRoute == iteracion) {
            return false;
        }
        return true;
    }
    
    // Calcula a que hora deberias estar en un punto de la ruta
    public calcularHoraStep (rutaConcreta, numeroStep) {
        if (numeroStep == rutaConcreta.legs[0].steps.length) {
        	if (typeof rutaConcreta.legs[rutaConcreta.legs.length-1].arrival_time != "undefined") {
        		return rutaConcreta.legs[rutaConcreta.legs.length-1].arrival_time.text.substring(0, 5);
        	} else {
        		return "";
        	}
        }
        if (typeof rutaConcreta.legs[0].departure_time == "undefined") {
        	return "";
        }
        var timeArray = rutaConcreta.legs[0].departure_time.text.split(":");
        var hours = timeArray[0].substring(0,2);
        var minutes = timeArray[1].substring(0,2);     
        var seconds = (hours * 60 * 60) + (minutes * 60);
        
        for (let i = 0; i < numeroStep; i++) {
            seconds += rutaConcreta.legs[0].steps[i].duration.value;
        }                     
        
        var finalMinutes = Math.floor((seconds / 60) % 60);
        var finalHours = Math.floor((seconds / 3600) % 24);
        
        var finalTime = '';
        if (finalMinutes < 10) {
            finalTime = '0' + finalMinutes;
        } else {
            finalTime = finalMinutes.toString(10);
        }
        
        if (finalHours < 10) {
            finalTime = '0' + finalHours + ':' + finalTime;
        } else {
            finalTime = finalHours.toString(10) + ':' + finalTime;
        }              
        
        return finalTime;
    }
    
    // Si la hora tiene menos dijitos esto es incorrecto, por ejemplo en el caso de 8:30am cogera 8:30a en lugar de 8:30
    // Funciona sin embargo para las horas con mas dijitos como 10:30am
    public getHoraSalida (rutaConcreta) {
    	if (typeof rutaConcreta.legs[0].departure_time != "undefined") {
    		return rutaConcreta.legs[0].departure_time.text.substring(0, 5);
    	} else {
    		return "";
    	}
    }
    
    // Si la hora tiene menos dijitos esto es incorrecto, por ejemplo en el caso de 8:30am cogera 8:30a en lugar de 8:30
    // Funciona sin embargo para las horas con mas dijitos como 10:30am
   	public getHoraLLegada (rutaConcreta) {
    	if (typeof rutaConcreta.legs[rutaConcreta.legs.length-1].arrival_time != "undefined") {
    		return rutaConcreta.legs[rutaConcreta.legs.length-1].arrival_time.text.substring(0, 5);
    	} else {
    		return "";
    	}
    }
    
    // cuando el foco se situa en el input 'origen' se limpia su contenido
    public inputAddressOrigen(event: any) {
        if (this.firstOrigen) {
            (<HTMLInputElement>document.getElementById('origen')).value = '';

        }
        this.firstOrigen = false;
    }
    
    // cuando el foco se situa en el input 'destino' se limpia su contenido
    public inputAddressDestino(event: any) {
        if (this.firstDestino) {
            (<HTMLInputElement>document.getElementById('destino')).value = '';

        }
        this.firstDestino = false;
    }
    
  /*--------------------------------------------- Eventos ------------------------------------------------------*/
  ngOnInit() {
    initMap();
    this.setTraducciones();
    this.depDate = new Date(Date.now());
    this.arrDate = new Date(Date.now());
  }

  /*--------------------------------------------- Constructores ------------------------------------------------*/
}



// WEBPACK FOOTER //
// ./src/app/optimal-path.component.ts